export enum THEME_COLOR {
    LIGHT = "light",
    DARK = "dark",
}
